export default __webpack_public_path__ + "static/media/runN.c8e4bfe8.mp4";